'use strict';

const $ = jQuery.noConflict();
$(function() {

	const accordion = {

		init: function() {
			this.cacheDOM();
			if (!this.$accordion.length) return;
			this.bindEvents();
			this.openFirst();
		},

		cacheDOM: function() {
			this.$accordion = $('.js-accordion');
			this.$toggles = this.$accordion.find('.js-accordion-toggle');
		},

		bindEvents: function() {
			this.$toggles.on('click', this.handleToggle);
		},

		openFirst: function() {
			const $firstItem = this.$accordion.find('.accordion__item').first();

			$firstItem.addClass('is-open');
			$firstItem.find('.js-accordion-toggle').attr('aria-expanded', 'true');
			$firstItem.find('.accordion__body').css('height', 'auto');
		},

		closeItem: function($item) {
			const $button = $item.find('.js-accordion-toggle');
			const $body = $item.find('.accordion__body');

			$body.animate({height: 0}, 350, function() {
				$item.removeClass('is-open');
				$button.attr('aria-expanded', 'false');
			});
		},

		handleToggle: function() {
			const $button = $(this);
			const $item = $button.closest('.accordion__item');
			const $accordion = $item.closest('.js-accordion');
			const isOpen = $item.hasClass('is-open');
			const $others = $accordion.find('.accordion__item.is-open').not($item);

			// Height that will collapse out above $item, so its post-collapse position can be predicted
			let collapsingHeightAbove = 0;

			$others.each(function() {
				const $other = $(this);

				if ($other.index() < $item.index()) {
					collapsingHeightAbove += $other.find('.accordion__body').outerHeight();
				}

				accordion.closeItem($other);
			});

			if (isOpen) {
				accordion.closeItem($item);
			} else {
				const $body = $item.find('.accordion__body');
				const scrollHeight = $body.prop('scrollHeight');

				$item.addClass('is-open');
				$button.attr('aria-expanded', 'true');
				$body.animate({height: scrollHeight}, 350, function() {
					$body.css('height', 'auto');
				});

				$('html, body').animate({
					scrollTop: $item.offset().top - collapsingHeightAbove - 100,
				}, 350);
			}
		},

	};

	accordion.init();
});
